import { createContext, type ReactNode } from "react";

import type { RuntimeConfig } from "./runtime";

const RuntimeConfigContext = createContext<RuntimeConfig | null>(null);

export function RuntimeConfigProvider({ config, children }: { config: RuntimeConfig | null; children: ReactNode }) {
  return <RuntimeConfigContext.Provider value={config}>{children}</RuntimeConfigContext.Provider>;
}

export { RuntimeConfigContext };
